/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  TriggerSkillSuggestionRequestBody,
  TriggerSkillSuggestionRequestBody$Outbound,
  TriggerSkillSuggestionRequestBody$outboundSchema,
} from "../components/triggerskillsuggestionrequestbody.js";

export type TriggerSkillSuggestionSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type TriggerSkillSuggestionSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type TriggerSkillSuggestionSecurity = {
  option1?: TriggerSkillSuggestionSecurityOption1 | undefined;
  option2?: TriggerSkillSuggestionSecurityOption2 | undefined;
};

export type TriggerSkillSuggestionRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  triggerSkillSuggestionRequestBody: TriggerSkillSuggestionRequestBody;
};

/** @internal */
export type TriggerSkillSuggestionSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const TriggerSkillSuggestionSecurityOption1$outboundSchema:
  z.ZodMiniType<
    TriggerSkillSuggestionSecurityOption1$Outbound,
    TriggerSkillSuggestionSecurityOption1
  > = z.pipe(
    z.object({
      projectSlugHeaderGramProject: z.string(),
      sessionHeaderGramSession: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function triggerSkillSuggestionSecurityOption1ToJSON(
  triggerSkillSuggestionSecurityOption1: TriggerSkillSuggestionSecurityOption1,
): string {
  return JSON.stringify(
    TriggerSkillSuggestionSecurityOption1$outboundSchema.parse(
      triggerSkillSuggestionSecurityOption1,
    ),
  );
}

/** @internal */
export type TriggerSkillSuggestionSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const TriggerSkillSuggestionSecurityOption2$outboundSchema:
  z.ZodMiniType<
    TriggerSkillSuggestionSecurityOption2$Outbound,
    TriggerSkillSuggestionSecurityOption2
  > = z.pipe(
    z.object({
      apikeyHeaderGramKey: z.string(),
      projectSlugHeaderGramProject: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      });
    }),
  );

export function triggerSkillSuggestionSecurityOption2ToJSON(
  triggerSkillSuggestionSecurityOption2: TriggerSkillSuggestionSecurityOption2,
): string {
  return JSON.stringify(
    TriggerSkillSuggestionSecurityOption2$outboundSchema.parse(
      triggerSkillSuggestionSecurityOption2,
    ),
  );
}

/** @internal */
export type TriggerSkillSuggestionSecurity$Outbound = {
  Option1?: TriggerSkillSuggestionSecurityOption1$Outbound | undefined;
  Option2?: TriggerSkillSuggestionSecurityOption2$Outbound | undefined;
};

/** @internal */
export const TriggerSkillSuggestionSecurity$outboundSchema: z.ZodMiniType<
  TriggerSkillSuggestionSecurity$Outbound,
  TriggerSkillSuggestionSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => TriggerSkillSuggestionSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => TriggerSkillSuggestionSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function triggerSkillSuggestionSecurityToJSON(
  triggerSkillSuggestionSecurity: TriggerSkillSuggestionSecurity,
): string {
  return JSON.stringify(
    TriggerSkillSuggestionSecurity$outboundSchema.parse(
      triggerSkillSuggestionSecurity,
    ),
  );
}

/** @internal */
export type TriggerSkillSuggestionRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
  TriggerSkillSuggestionRequestBody: TriggerSkillSuggestionRequestBody$Outbound;
};

/** @internal */
export const TriggerSkillSuggestionRequest$outboundSchema: z.ZodMiniType<
  TriggerSkillSuggestionRequest$Outbound,
  TriggerSkillSuggestionRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    triggerSkillSuggestionRequestBody:
      TriggerSkillSuggestionRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
      triggerSkillSuggestionRequestBody: "TriggerSkillSuggestionRequestBody",
    });
  }),
);

export function triggerSkillSuggestionRequestToJSON(
  triggerSkillSuggestionRequest: TriggerSkillSuggestionRequest,
): string {
  return JSON.stringify(
    TriggerSkillSuggestionRequest$outboundSchema.parse(
      triggerSkillSuggestionRequest,
    ),
  );
}
